import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import store from "./Redux/store";
import { Provider } from "react-redux";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient();

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      </QueryClientProvider>
      <ToastContainer />
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);
